import React from 'react';
import PropTypes from 'prop-types';
import css from './CwDropdown.scss';
import cx from 'classnames';
import { getMouseMode } from '../../utils/CwThemeService';
/**
 * Based on react-autocomplete:
 * https://github.com/reactjs/react-autocomplete
 */

class CwDropdownItem extends React.Component {

  handleClick = () => {
    if (this.props.onClick) {
      this.props.onClick(this.props.item);
    }
  };

  handleMouseEnter = (event) => {
    if (this.props.onMouseEnter) {
      this.props.onMouseEnter(this.props.index, { x: event.clientX, y: event.clientY });
    }
  };

  handleMouseDown = () => {
    if (this.props.onMouseDown) {
      this.props.onMouseDown(true);
    }
  };

  handleMouseMove = (event) => {
    if (this.props.onMouseMove) {
      this.props.onMouseMove({ x: event.clientX, y: event.clientY });
    }
  }

  render() {
    let itemClassName;
    let itemStyle;
    const padding = getMouseMode() ? 8 : 16;
    if (this.props.isPicker) {
      itemClassName = cx(css.dropDownPicker, { [css.highlightedItem]: this.props.isHighlighted });
    }
    else {
      itemClassName = cx(css.dropDownItem, { [css.highlightedItem]: this.props.isHighlighted });
    }
    if (this.props.itemHeight) {
      itemStyle = { height: this.props.itemHeight - padding };
    }
    return (
      <div className={itemClassName}
        style={itemStyle}
        onClick={this.handleClick}
        onMouseEnter={this.handleMouseEnter}
        onMouseDown={this.handleMouseDown}
        onMouseMove={this.handleMouseMove}
        ref={(div) => this.div = div} >
        {this.props.item.leftWidget}
        {this.props.item.name}
      </div>
    );
  }
}

CwDropdownItem.propTypes = {
  /**
   * Determines whether the current dropdown item is highlighted
   */
  isHighlighted: PropTypes.bool,
  /**
   * Determines whether the current dropdown item is the picker
   */
  isPicker: PropTypes.bool,
  /**
   * The dropdown item being rendered. Must contain at least "id" and "name" fields.
   */
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    name: PropTypes.string,
    leftWidget: PropTypes.element
  }),
  /**
   * Callback function that is fired when dropdown item is clicked.
   */
  onClick: PropTypes.func,
  /**
   * Callback function that is fired when dropdown item is hovered over.
   */
  onMouseEnter: PropTypes.func,
  /**
   * Callback function that is fired before onClick. Typically used to ignore blur in order to prevent dropdown item from derezzing before a selection is registered.
   */
  onMouseDown: PropTypes.func,
  /**
   * The index of the dropdown item being rendered.
   */
  index: PropTypes.number,
  /**
   * Used to override height on individual items in the drop down
   */
  itemHeight: PropTypes.number
};

CwDropdownItem.defaultProps = {
  item: { id: null, name: null }
};

export default CwDropdownItem;


// WEBPACK FOOTER //
// ./src/components/cwdropdown/CwDropdownItem.jsx